module.exports = __webpack_public_path__ + "media/images/bluepinrts_white-b6adaf8e848c0943ab25cce68f35707c.jpg";